import { SingletonRedirect } from "@/components/SingletonRedirect";

export function MfaList() {
  return <SingletonRedirect resource="mfa" />;
}
